import { useState } from 'react';
import { AvatarGroup, AvatarGroupItem } from '@fluentui/react-components';
import { TeamVacationPopup } from './TeamVacationPopup';
import {
  DayStringStyled,
  TeamVacationCircleContainer,
  TeamVacationSquare,
} from './styles/TeamVacationCircle.styled';
import { createPortal } from 'react-dom';
import { isMobile } from 'react-device-detect';
import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

interface TeamVacationCircleProps {
  month: number;
  employeesOverflow?: {
    name: string;
    colorPersona: string;
    backgroundPersona: string;
  }[];
  employees?: {
    name: string;
    colorPersona: string;
    backgroundPersona: string;
  }[];
  date: string;
  target: Element;
  currentUser: {
    target: Element;
    date: string;
    status: string;
    vacationType: string;
    name: string;
  };
}

export const TeamVacationCircle = ({
  month,
  employees,
  employeesOverflow,
  date,
  target,
  currentUser,
}: TeamVacationCircleProps) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const dayString = date?.split(',')[0] || currentUser.date.split(',')[0];
  const firstThreeEmployeeColors = employees.map((employee) => {
    return {
      color: employee.colorPersona,
      background: employee.backgroundPersona,
    };
  });

  return (
    <TeamVacationSquare
      currentUserHasVacation={currentUser.name === 'currentUser'}
      onMouseEnter={() => setShowDropDown(true)}
      onMouseLeave={() => setShowDropDown(false)}
    >
      {currentUser.name && !isMobile && (
        <DayStringStyled>{dayString}</DayStringStyled>
      )}
      <TeamVacationCircleContainer
        firstThreeEmployeeColors={firstThreeEmployeeColors}
      >
        <AvatarGroup layout="pie" size={16} as="div">
          {employees.map((employee, index) => {
            return (
              index < 3 && (
                <AvatarGroupItem
                  key={generateReactKey(
                    KeyRoots.TIME_OFF_AVATAR_GROUP_ITEM,
                    index
                  )}
                  name={employee.name}
                />
              )
            );
          })}
        </AvatarGroup>
      </TeamVacationCircleContainer>
      {showDropDown &&
        !isMobile &&
        createPortal(
          <TeamVacationPopup
            month={month}
            employeesOverflow={employeesOverflow}
            date={date}
            currentUser={currentUser}
          />,
          target
        )}
    </TeamVacationSquare>
  );
};
